import { useCallback, useEffect } from "react";
import { P2Modal } from "react-bootstrap-common-script";
import { useAppDispatch, useAppSelector } from "../../redux/hook";
import {
  setIsClickedDashboard,
  setLeavePageModalOpen,
  setNavigatingValue,
} from "../../redux/slices/leave-page-slice";
import { To, useNavigate } from "react-router-dom";
import { HouseholdFormData, ReasonFormData } from "../../models/classes/ApplicationStep1.class";
import { ApplicationStep2 } from "../../models/classes/ApplicationStep2.class";
import { ApplicationStep3 } from "../../models/classes/ApplicationStep3.class";
import { FileItem } from "../../models/polymer/Document.model";
import { cloneDeep } from "lodash";
import { Helpers } from "../../utils/helper";
import { ApplicationStep5 } from "../../models/classes/ApplicationStep5.class";
interface LeavingPageModalProps {
  requireConfirmationOnBack?: boolean;
  onCancel?: () => void;
  onSubmit?: () => void;
  householdFormValues?: HouseholdFormData;
  reasonValues?: ReasonFormData;
  financingValues?: ApplicationStep2;
  conveyancingValue?: ApplicationStep3;
  filesItemsStorage?: FileItem[];
  reviewEndorseValues?: ApplicationStep5;
}

export default function LeavingPageModal({
  requireConfirmationOnBack = false,
  onCancel,
  onSubmit,
  householdFormValues,
  reasonValues,
  financingValues,
  conveyancingValue,
  filesItemsStorage,
  reviewEndorseValues,
}: LeavingPageModalProps) {
  const leavePageSlice = useAppSelector((state) => state.app.LeavePageSlice);
  const application1FormData = useAppSelector(state => state.app.ApplicationStep1Slice.formData);
  const application2FormData = useAppSelector(state => state.app.ApplicationStep2Slice.formData);
  const application3FormData = useAppSelector(state => state.app.ApplicationStep3Slice.formData);
  const application4FormData = useAppSelector(state => state.app.ApplicationStep4Slice.formData);
  const application5FormData = useAppSelector(state => state.app.ApplicationStep5Slice.formData);
  const AppDispatch = useAppDispatch();
  const navigate = useNavigate();
  

  useEffect(()=>{
    if(leavePageSlice.isClickedDashboard){
      if(householdFormValues && reasonValues){
        const tempHouseholdFormValues = cloneDeep(householdFormValues);
        const tempApplication1Household = cloneDeep(application1FormData.household);
        const tempReasonValues = cloneDeep(reasonValues);
        const tempApplication1Reason = cloneDeep(application1FormData.reason);
        if(householdFormValues)
        tempHouseholdFormValues.owners = [];
        tempHouseholdFormValues.occupiers = [];
        tempApplication1Household.owners = [];
        tempApplication1Household.occupiers = [];
        Helpers.replaceUndefinedWithEmptyString(tempHouseholdFormValues);
        Helpers.replaceUndefinedWithEmptyString(tempApplication1Household);
        Helpers.replaceUndefinedWithEmptyString(tempReasonValues);
        Helpers.replaceUndefinedWithEmptyString(tempApplication1Reason);
    
        if(leavePageSlice.isClickedDashboard){
          if(JSON.stringify(tempReasonValues) == JSON.stringify(tempApplication1Reason) && JSON.stringify(tempHouseholdFormValues) == JSON.stringify(tempApplication1Household)){
            if (leavePageSlice.navigatingValue) {
              navigate(leavePageSlice.navigatingValue as To);
            } 
          }else{
            AppDispatch(setLeavePageModalOpen(true));
            AppDispatch(setNavigatingValue("/"))
          }
        }
      }   
      else if(financingValues){
        handleOnValueChanged(financingValues,application2FormData);
      }else if(conveyancingValue){
        handleOnValueChanged(conveyancingValue,application3FormData);
      }else if(filesItemsStorage){
        handleOnValueChanged(filesItemsStorage,application4FormData.file_items);
      }else if(reviewEndorseValues){
        handleOnValueChanged(reviewEndorseValues,application5FormData);
      }
      AppDispatch(setIsClickedDashboard(false));  
    } 
  },[leavePageSlice.isClickedDashboard])

  const handleOnValueChanged = (value:any, sliceValue:any) =>{
    const tempValue = cloneDeep(value);
    const tempSliceValues = cloneDeep(sliceValue);
    Helpers.replaceUndefinedWithEmptyString(tempValue);
    Helpers.replaceUndefinedWithEmptyString(tempSliceValues);

    if(leavePageSlice.isClickedDashboard){
      if(JSON.stringify(tempValue) == JSON.stringify(tempSliceValues)){
        if (leavePageSlice.navigatingValue) {
          navigate(leavePageSlice.navigatingValue as To);
        } 
      }else{
        AppDispatch(setLeavePageModalOpen(true));
        AppDispatch(setNavigatingValue("/"))
      }
    }
  }

  const handleCloseModal = useCallback(() => {
    AppDispatch(setLeavePageModalOpen(false));
  }, [AppDispatch]);

  const handleNavigation = useCallback(() => {
    if (leavePageSlice.navigatingValue) {
      navigate(leavePageSlice.navigatingValue as To);
    }
  }, [leavePageSlice.navigatingValue, navigate]);

  const handleCancel = useCallback(() => {
    handleCloseModal();
    onCancel?.();
    handleNavigation();
  }, [handleCloseModal, onCancel, handleNavigation]);

  const handleSubmit = useCallback(() => {
    handleCloseModal();
    onSubmit?.();
    handleNavigation();
  }, [handleCloseModal, onSubmit, handleNavigation]);

  useEffect(() => {
    if (requireConfirmationOnBack) {
      window.onpopstate = () => {
        window.history.pushState(null, "", window.location.href);
        AppDispatch(setIsClickedDashboard(true));
        AppDispatch(setNavigatingValue("/"));
      };
    }
  }, [requireConfirmationOnBack]);

  useEffect(() => {
    console.log("requireConfirmationOnBack",requireConfirmationOnBack)
    if(requireConfirmationOnBack){
       window.history.pushState(null, "", window.location.href);
    }
  }, [requireConfirmationOnBack]);
  return (
    <P2Modal
      isOpen={leavePageSlice.isModalOpen}
      onCloseModal={handleCloseModal}
      variant="default"
      title={`Save as draft?`} // in future to change to .length
      primaryButtonText="No, remove application"
      secondaryButtonText="Yes, save as draft"
      primaryButtonFunction={handleCancel}
      secondaryButtonFunction={handleSubmit}
      children={
        <p style={{marginBottom:24}}>You are leaving the application. Do you want to save the current application as draft?</p>
      }
    />
  );
}
